<script setup>
    import { ref } from "vue";
import PageHeader from '@/Components/PageHeader.vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    import TableSingle from "@/Components/TableSingle.vue";
    
    defineProps({
        colegios: Array
    });
    const rutaprefijo = ref('colegio');
    const modulo = ref('colegio');
</script>

<template>
    <Head title="Colegios Config." />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Colegios" />
        </template>

        <div class="py-12">
            <div class="container mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <CardBox class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <TableSingle :modulo="modulo" :data="colegios"  :ruta="rutaprefijo"/>
                        </CardBox>
                        
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
